import React from 'react';
import styled from 'styled-components';
import { InputText } from '../componentes_formulario/inputs/inputtext';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cargar_PuntosFacturacion } from '../../../actions/ventas/act_ven02';
import { seleccionar_NumeroComprobante } from '../../../actions/generales/act_gen04';
import { getItemDatosSesion } from '../../../funciones_globales/manejosesion';
import { completar_String } from '../../../funciones_globales/format';

const ContainerNumeroComprob = styled.div`
    width: 100%;
`;

const Button = styled.button`
    height: 25px;
    padding: 0px 10px;
    font-size: 11px;
`;

const estiloSelectPtoFact = {
    height: '25px',
    width: '45%',
    padding: '2px',
    fontSize: '11px',
    lineHeight: 1.5,
    borderRadius: '3px',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
};

const estiloNumeroComprob = {    
    width: '55%'
};

class NumeroComprobante extends React.Component{
    constructor(props){
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.completarNumeroComprob = this.completarNumeroComprob.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        let numeroComprobante = this.props.numeroComprobante;
        if (name==='serieComprob'){
            numeroComprobante = value + '-' + numeroComprobante.slice(8);
        }

        if (name==='numeroComprob'){
            numeroComprobante = numeroComprobante.slice(0, 7) + '-' + value;
        }

        this.props.seleccionar_NumeroComprobante(numeroComprobante);
    }

    componentDidMount(){
        let puntoFacturacionDefault;

        if (this.props.puntosFacturacion.length===0){
            
            let empresaId = getItemDatosSesion('empresaActual')?JSON.parse(getItemDatosSesion('empresaActual')).Id:'';
            let usuario = getItemDatosSesion('usuario');
            
            this.props.cargar_PuntosFacturacion(empresaId, usuario, 'T')
            .then(()=>{
                for(let i=0; i<this.props.puntosFacturacion.length; i++){
                    if (this.props.puntosFacturacion[i].EsDefault==='S'){
                        puntoFacturacionDefault = this.props.puntosFacturacion[i];
                        break;
                    }
                }
                let numeroComprobante = puntoFacturacionDefault.Establecimiento + '-' + puntoFacturacionDefault.PtoEmision;
                this.props.seleccionar_NumeroComprobante(numeroComprobante);
            });
        }else{
            for(let i=0; i<this.props.puntosFacturacion.length; i++){
                if (this.props.puntosFacturacion[i].EsDefault==='S'){
                    puntoFacturacionDefault = this.props.puntosFacturacion[i];
                    break;
                }
            }
            let numeroComprobante = puntoFacturacionDefault.Establecimiento + '-' + puntoFacturacionDefault.PtoEmision;
            this.props.seleccionar_NumeroComprobante(numeroComprobante);
        }
    }

    completarNumeroComprob(){
        let numeroComprobante = this.props.numeroComprobante.slice(8);
        numeroComprobante = this.props.numeroComprobante.slice(0, 7) + '-' + ((numeroComprobante.length<9 && numeroComprobante.length>0)?completar_String(numeroComprobante, '0', 9):numeroComprobante);
        this.props.seleccionar_NumeroComprobante(numeroComprobante);        
    }

    render(){
        let puntosFact = (this.props.puntosFacturacion === null || this.props.puntosFacturacion === undefined)?[]:this.props.puntosFacturacion;
        
        return(
            <ContainerNumeroComprob className='input-group'>
                <select name='serieComprob' value={this.props.numeroComprobante.slice(0, 7)} className="form-control" style={estiloSelectPtoFact} 
                    title="Seleccione un punto de facturación" onChange={this.handleInputChange}>
                    {puntosFact.map((pto, i)=>{
                        return <option key={i} value={pto.Establecimiento + '-' + pto.PtoEmision}>{pto.Establecimiento + '-' + pto.PtoEmision}</option>;
                    })}
                </select>
                <InputText name='numeroComprob' style={estiloNumeroComprob} autoComplete='off' value={this.props.numeroComprobante.slice(8)} type='text' className='form-control'
                    placeholder={this.props.placeholder} maxLength='9' onChange={this.handleInputChange} onBlur={this.completarNumeroComprob} onFocus={this.props.func_OnFocus}
                />
                <span className='input-group-btn'>
                  <Button className='btn btn-default' type='button' onClick={this.props.funcBuscarComprobante}><i className='fa fa-search' aria-hidden='true'/></Button>
               </span>
        </ContainerNumeroComprob>
        )
    }
}

const mapStateToProps = ((state) => {
    return {    puntosFacturacion: state.ventas.puntosFact,
                numeroComprobante: state.generales.numComprobSel }
});
  
const mapDispatchToProps = ((dispatch) => {
    return bindActionCreators({ cargar_PuntosFacturacion, seleccionar_NumeroComprobante }, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(NumeroComprobante);